// Site identity and page metadata. Plain data with no "@/" imports or process.env,
// because the Cloudflare Worker (worker/index.js) bundles this file too and renders
// the same titles, descriptions and links into the HTML crawlers receive.

export const SITE_URL = "https://www.piyushkirannayak.com";

// Absolute URLs for structured data and the sitemap. The app itself reads the
// backend from REACT_APP_BACKEND_URL; search engines always need the live host.
export const API_ORIGIN = "https://api.piyushkirannayak.com";

export const ARTIST = {
  name: "Dr Piyush Kiran Nayak",
  alternateNames: ["Piyush Kiran Nayak", "डॉ. पीयूष किरण नायक"],
  title: "Mithila / Madhubani Artist",
  phone: "+91 91117 39433",
  phoneHref: "tel:+919111739433",
  whatsapp: "https://wa.me/919111739433",
  email: "piyush.mithilaart@gmail.com",
  instagram: "https://instagram.com/piyushart_gallery",
  facebook: "https://facebook.com/piyushart_gallery",
  location: "Bhopal, India",
};

export const DEFAULT_ROBOTS = "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";

export const HOME = {
  path: "/",
  name: "Home",
  title: "Dr Piyush Kiran Nayak — Mithila / Madhubani Artist",
  description:
    "A contemporary digital gallery of original Mithila (Madhubani) paintings by Dr Piyush Kiran Nayak — artworks, stories, the world of Mithila, and commissions.",
  image: "/assets/artist-hero.jpg",
};

// Each chapter of the home page also lives at its own URL, so search engines can
// index and list them separately (sitelinks). Keys match the section ids on Home.
export const PAGES = {
  artist: {
    path: "/about",
    name: "The Artist",
    title: "About the Artist — Dr Piyush Kiran Nayak",
    image: `${API_ORIGIN}/api/uploads/portrait.jpg`,
    description:
      "Dr Piyush Kiran Nayak is a Mithila / Madhubani artist in Bhopal — from childhood drawings to a formal study of the Mithila tradition at Shilp Kala Vidyapeeth.",
  },
  gallery: {
    path: "/gallery",
    name: "Gallery",
    title: "Gallery of Mithila Paintings — Dr Piyush Kiran Nayak",
    description:
      "Original Mithila (Madhubani) paintings by Dr Piyush Kiran Nayak — gods and goddesses, nature, mythology, festivals and folk life, each with a catalogue note.",
  },
  world: {
    path: "/mithila-art",
    name: "World of Mithila",
    title: "The World of Mithila Art — Motifs, Styles & History",
    description:
      "A guide to Mithila (Madhubani) painting — its origins on the walls of Bihar, the five classical styles, and what the fish, lotus, peacock and sun symbolise.",
  },
  practice: {
    path: "/practice",
    name: "The Practice",
    title: "The Practice — How Dr Piyush Kiran Nayak Paints",
    description:
      "Tradition, observation, interpretation and craft — the four pillars of Dr Piyush Kiran Nayak's Mithila painting practice, line before colour.",
  },
  recognition: {
    path: "/recognition",
    name: "Recognition",
    title: "Recognition & Credentials — Dr Piyush Kiran Nayak",
    description:
      "Licensed artisan with the Government of India, art educator and 25+ years with Indian folk art — the credentials and honours of Dr Piyush Kiran Nayak.",
  },
  exhibitions: {
    path: "/exhibitions",
    name: "Exhibitions",
    title: "Exhibitions & Journey — Dr Piyush Kiran Nayak",
    description:
      "Exhibitions of Mithila / Madhubani art featuring Dr Piyush Kiran Nayak in Bhopal, Patna, New Delhi and beyond — past and forthcoming.",
  },
  contact: {
    path: "/contact",
    name: "Contact",
    title: "Commissions & Contact — Dr Piyush Kiran Nayak",
    description:
      "Commission an original Mithila painting, or enquire about exhibitions, workshops and collaborations with Dr Piyush Kiran Nayak in Bhopal, India.",
  },
};

export const absoluteUrl = (path = "/") => new URL(path, SITE_URL).href;

// Uploaded images are stored as "/api/uploads/…" paths on the backend.
export const apiAssetUrl = (path) => (path && path.startsWith("/api") ? `${API_ORIGIN}${path}` : path);

export const artworkPath = (art) => `/artwork/${art.id}`;

export const isHonour = (ev) => ["Recognition", "Award"].includes(ev.event_type);

export const artworkAlt = (art) => `${art.title} — Mithila (Madhubani) painting by ${ARTIST.name}`;
